import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

export default function Unlock() {
  const [password, setPassword] = useState('');
  const { user, unlockSession, logout, isLoading, error, clearError } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();

    try {
      await unlockSession(password);
    } catch {
      // Error is handled in the store
    }
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="max-w-md w-full space-y-8">
        {/* Logo and welcome back */}
        <div className="text-center">
          <span className="text-6xl">🔐</span>
          <h1 className="mt-4 text-2xl font-bold text-gray-900 dark:text-white">
            Welcome back{user?.name ? `, ${user.name.split(' ')[0]}` : ''}!
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Enter your password to unlock your encrypted data
          </p>
        </div>

        {/* Unlock form */}
        <div className="card p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 p-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Password
              </label>
              <input
                id="password"
                type="password"
                required
                autoComplete="current-password"
                autoFocus
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input"
                placeholder="Enter your password"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading || !password}
              className="btn-primary w-full"
            >
              {isLoading ? (
                <>
                  <span className="spinner mr-2" />
                  Unlocking...
                </>
              ) : (
                'Unlock'
              )}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Not {user?.email}?
            </p>
            <button
              onClick={handleLogout}
              className="mt-2 text-sm text-primary-600 hover:text-primary-700 dark:text-primary-400 font-medium"
            >
              Sign out and use a different account
            </button>
          </div>
        </div>

        {/* Security note */}
        <div className="text-center text-xs text-gray-500 dark:text-gray-500 space-y-1">
          <p>Your data is encrypted end-to-end</p>
          <p>Your password never leaves your device</p>
        </div>
      </div>
    </div>
  );
}
